import React, { useState, useEffect } from "react";
import UserIcon from "../../assets/images/user.png";
import SubscriberIcon from "../../assets/images/subscriber.png";
import CompanyUsersCard from "./CompanyUsersCard";
import Carousel from "react-multi-carousel";
import { useSnackbar } from "notistack";
import { fetchAdminDashboardData } from "../../utils/apis";

// brand purple + the site's flow / slow / jam signal colors
const backgroundColors = ["#6e00dc", "#13946a", "#c97d0b", "#d63a41"];

const responsive = {
  superLargeDesktop: {
    breakpoint: { max: 4000, min: 3000 },
    items: 5,
  },
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 4,
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 3,
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1,
  },
};

const StatCard = ({ title, tone, icon, value }) => (
  <div className={`stat-card ${tone ? `stat-card--${tone}` : ""}`}>
    <div className="stat-card__head">
      {icon ? (
        <span className="stat-card__icon">
          <img src={icon} alt="" />
        </span>
      ) : (
        <span className="stat-card__dot" />
      )}
      <span className="stat-card__label">{title}</span>
    </div>
    <div className="stat-card__value">{value ?? "—"}</div>
  </div>
);

const Dashboard = () => {
  const { enqueueSnackbar } = useSnackbar();
  const [dashboardData, setDashboardData] = useState(null);

  useEffect(() => {
    const fetchDashboardData = async () => {
      const data = await fetchAdminDashboardData(enqueueSnackbar);
      if (data) setDashboardData(data);
    };
    fetchDashboardData();
  }, [enqueueSnackbar]);

  const analysisCardsInfo = [
    { title: "Subscribers", tone: "flow", icon: SubscriberIcon, dataKey: "subscribers" },
    { title: "Trial Users", tone: "brand", icon: UserIcon, dataKey: "trialUsers" },
    { title: "Expired Users", tone: "jam", dataKey: "expiredUsers" },
  ];
  const messageCardsInfo = [
    { title: "Daily Messages", tone: "brand", dataKey: "dailyMessages" },
    { title: "Monthly Messages", tone: "brand", dataKey: "monthlyMessages" },
    { title: "Yearly Messages", tone: "brand", dataKey: "yearlyMessages" },
  ];

  const paymentCardsInfo = [
    { title: "Paid Amounts", tone: "flow", dataKey: "paidAmount" },
    { title: "Pending Payments", tone: "slow", dataKey: "pendingAmount" },
    { title: "Failed Subscriptions", tone: "jam", dataKey: "failedSubscriptions" },
  ];
  return (
    <>
      <section className="dash-section">
        <h2 className="page-title">Top company users</h2>
        {dashboardData?.topCompanyUsers?.length > 0 && (
          <div className="admin-dashboard-card-layout-wrapper" style={{ width: "100%" }}>
            <Carousel itemClass="px-2" containerClass="carousel-container" partialVisbile responsive={responsive}>
              {dashboardData.topCompanyUsers.map((item, index) => (
                <CompanyUsersCard key={item._id} data={item} color={backgroundColors[index % backgroundColors.length]} />
              ))}
            </Carousel>
          </div>
        )}
      </section>

      <section className="dash-section">
        <h2 className="page-title">Analysis</h2>
        <div className="stat-grid">
          {analysisCardsInfo.map((card) => (
            <StatCard key={card.title} {...card} value={dashboardData?.[card.dataKey]} />
          ))}
        </div>
      </section>

      <section className="dash-section">
        <h2 className="page-title page-title--sm">Messages</h2>
        <div className="stat-grid">
          {messageCardsInfo.map((card) => (
            <StatCard key={card.title} {...card} value={dashboardData?.[card.dataKey]} />
          ))}
        </div>
      </section>

      <section className="dash-section">
        <h2 className="page-title page-title--sm">Payments</h2>
        <div className="stat-grid">
          {paymentCardsInfo.map((card) => (
            <StatCard key={card.title} {...card} value={dashboardData?.[card.dataKey]} />
          ))}
        </div>
      </section>
    </>
  );
};

export default Dashboard;
